export const GET_CLOSINGDATA = "GET_CLOSINGDATA";
export const GET_CLOSINGDATA_UPDATE = "GET_CLOSINGDATA_UPDATE";
export const COPY_CLOSINGDATA = "COPY_CLOSINGDATA"